export default "__VITE_ASSET__nvRr56pW__"